"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var quards_1 = require("../../../utils/quards");
var selectors_1 = require("../selectors");
var SeoBannerImage = function (props) {
    var src = (0, quards_1.guardString)((0, selectors_1.useSeoTypeSelector)(props.src));
    var alt = (0, quards_1.guardString)((0, selectors_1.useSeoTypeSelector)(props.alt));
    return react_1.default.createElement("img", { loading: "lazy", src: src, alt: alt, className: props.className });
};
exports.default = SeoBannerImage;
